import { useState, useEffect } from "react";
import BallLoader from "../components/shared/BallLoader";
import { useNavigate, useSearchParams } from "react-router-dom";
import { ShieldCheck, XCircle } from "lucide-react";
import axios from "axios";
import { API } from "../contexts/AuthContext";
import { useTranslation } from "@/i18n";

export const CancelEmailChangePage = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const { t } = useTranslation();
  const [status, setStatus] = useState("processing");
  const [message, setMessage] = useState("");

  useEffect(() => {
    const token = searchParams.get("token");
    if (!token) {
      setStatus("error");
      setMessage("Invalid link.");
      return;
    }

    (async () => {
      try {
        const res = await axios.post(`${API}/auth/cancel-email-change`, { token });
        setStatus("success");
        setMessage(res.data.message);
        // Force logout - account is now locked
        localStorage.removeItem("token");
      } catch (err) {
        setStatus("error");
        setMessage(err.response?.data?.detail || "Failed to cancel.");
      }
    })();
  }, [searchParams]);

  return (
    <div className="app-container px-8 flex flex-col justify-center min-h-screen">
      <div className="text-center max-w-sm mx-auto">
        <h1 className="text-3xl font-bold mb-8">Xelanti</h1>
        
        {status === "processing" && (
          <>
            <BallLoader size={48} className="mb-4" />
            <p className="text-gray-600 dark:text-gray-300">{t('emailChange.cancelling')}</p>
          </>
        )}
        
        {status === "success" && (
          <>
            <ShieldCheck size={64} className="mx-auto mb-4 text-green-500" />
            <h2 className="text-2xl font-bold mb-3">{t('emailChange.accountSecured')}</h2>
            <p className="text-gray-600 dark:text-gray-300 mb-6">{message}</p>
            <p className="text-sm text-gray-500 dark:text-gray-400 mb-8">
              {t('emailChange.lockedBody')}
            </p>
            <button onClick={() => navigate("/forgot-password")} className="clean-btn-primary w-full">
              {t('forgot.resetPassword')}
            </button>
          </>
        )}
        
        {status === "error" && (
          <>
            <XCircle size={64} className="mx-auto mb-4 text-red-500" />
            <h2 className="text-2xl font-bold mb-3">{t('emailChange.couldntCancel')}</h2>
            <p className="text-gray-600 dark:text-gray-300 mb-8">{message}</p>
            <button onClick={() => navigate("/login")} className="clean-btn-primary w-full">
              {t('verify.backToSignIn')}
            </button>
          </>
        )}
      </div>
    </div>
  );
};
